import browserDetection from '@wix/santa-browser-detection';
const getUserAgent = () => { var _a; return (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent; };
export const isFirefox = () => {
    const detected = browserDetection(getUserAgent());
    return !!detected.browser.firefox;
};
